import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <p className='footer-text'>
        &copy; Restaurants Search Engine. All rights reserved.
      </p>
    </footer>
  )
}

export default Footer
